import React, { useState } from "react";
import {
  Select,
  MyMessage,
  InputField,
  AddPageShell,
  AddSection,
} from "../../components/Component";
import { useDoSeeDataContext } from "../../../context/DoSeeDataContext";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { defaultImage } from "../../../lib/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../ui/ImageKitLibrary";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import BestTimeToVisit from "../../components/BestTimeToVisit";
import Pricing from "../../components/Pricing";
import GenerateDescription from "../utils/GenerateDescription";
import {
  ContactSection,
  SocialSection,
  DescriptionSection,
} from "../utils/AddSections";
import { FiImage, FiClock, FiSun, FiDollarSign } from "react-icons/fi";
import { FaPaw } from "react-icons/fa";

const Add = () => {
  const { createOneContent } = useDoSeeDataContext();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
    tags,
  } = useGeoPositionContext();

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [title, setTitle] = useState(null);
  const [venue, setVenue] = useState(null);
  const [thumbnail, setThumbnail] = useState(defaultImage);
  const [thumbnailId, setThumbnailId] = useState("img_cdn_id");
  const [openedDays, setOpenedDays] = useState<any>(
    "Monday, Tuesday, Wednesday, Thursday, Friday, Saturday, Sunday"
  );
  const [openedAt, setOpenedAt] = useState<any>("06:00");
  const [closedAt, setClosedAt] = useState<any>("22:00");
  const [fee, setFee] = useState(0);
  const [vip, setVip] = useState(0);
  const [vvip, setVvip] = useState(0);
  const [email, setEmail] = useState(null);
  const [payLink, setPayLink] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [whatsapp, setWhatsapp] = useState("none");
  const [facebook, setFacebook] = useState("none");
  const [twitter, setTwitter] = useState("none");
  const [instagram, setInstagram] = useState("none");
  const [youtube, setYoutube] = useState("none");
  const [hashtags, setHashtags] = useState("");
  const [formattedAddress, setFormattedAddress] = useState(null);
  const [featured, setFeatured] = useState<any>("no");
  const [promoted, setPromoted] = useState<any>("no");
  const [safariStatus, setSafariStatus] = useState(1);
  const [expo, setExpo] = useState(0);
  const [showTop, setShowTop] = useState(0);
  const [description, setDescription] = useState(null);
  const [bestTime, setBestTime] = useState<any[]>([]);
  const [pricing, setPricing] = useState<any[]>([]);
  const [showDescriptionModal, setShowDescriptionModal] = useState<any>(null);

  const safariRoutes = "/data/safari";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
    setThumbnail(null);
    setThumbnailId(null);
    setTitle(null);
    setVenue(null);
    setOpenedDays(null);
    setOpenedAt(null);
    setClosedAt(null);
    setFee(0);
    setVip(0);
    setVvip(0);
    setExpo(0);
    setEmail(null);
    setPayLink(null);
    setPhoneNumber(null);
    setWhatsapp("none");
    setFacebook("none");
    setTwitter("none");
    setInstagram("none");
    setYoutube("none");
    setHashtags("none");
    setFormattedAddress(null);
    setFeatured(0);
    setDescription(null);
    setShowTop(0);
    setBestTime([]);
    setPricing([]);
  };

  const responses = (error: any, message: any) => {
    setError(error);
    setLoading(false);
    setSuccess(!error);
    setErrorMessage(message);
  };

  const addOneSafariHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      responses(true, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      country_id: country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      title: title,
      slug: title ? (title as any).toLowerCase().replace(/\s/g, "_") : null,
      description: description,
      city_level: "level",
      venue: venue,
      opened_days: openedDays,
      opened_at: openedAt,
      closed_at: closedAt,
      fee: fee,
      vip: vip,
      vvip: vvip,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      phone_number: phoneNumber,
      email_address: email,
      pay_link: payLink,
      whatsapp: whatsapp,
      facebook: facebook,
      twitter: twitter,
      instagram: instagram,
      youtube: youtube,
      hashtag: `${tags}, ${hashtags}`,
      audio_ad: "none",
      formatted_address: formattedAddress,
      country_short: "none",
      status: safariStatus,
      featured: featured,
      promoted: promoted,
      expo: expo,
      show_top: showTop,
      best_time_to_visit: bestTime?.length > 0 ? String(bestTime) : null,
      pricing: pricing,
    };

    const { status, message } = await createOneContent({
      data: data,
      content: _TYPES_.SAFARI,
    });
    if (status === 200 || status === 201) {
      cleanFields();
      responses(false, message);
    } else {
      responses(true, message);
    }
  };

  const clearMessages = () => {
    setError(null as any);
    setSuccess(null as any);
  };

  return (
    <AddPageShell
      backRoute={safariRoutes}
      eyebrow="DoSee Data • Safari"
      title="Add Safari"
      subtitle={`Showcase a safari experience in ${entry_label || "this destination"}.`}
      icon={<FaPaw className="h-5 w-5" />}
      modals={
        showDescriptionModal ? (
          <GenerateDescription
            setDescription={setDescription}
            setShowDescriptionModal={setShowDescriptionModal}
          />
        ) : null
      }
      loading={loading}
      submitLabel="Add Safari"
      onSubmit={addOneSafariHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null as any);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Cover Image"
        hint="Wildlife or landscape photo."
        icon={<FiImage className="h-4 w-4" />}
      >
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={image_kit_folder(country_name, FOLDERS.SAFARI)}
        />
      </AddSection>

      <AddSection
        title="Best Time To Visit"
        hint="Months that are ideal for this safari."
        icon={<FiSun className="h-4 w-4" />}
      >
        <BestTimeToVisit bestTime={bestTime} setBestTime={setBestTime} />
      </AddSection>

      <AddSection title="Safari Details" hint="Title, venue and ranking.">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <InputField
            props={{
              id: "title",
              title: "Title",
              type: "text",
              required: true,
              value: title || "",
              onChange: (e: any) => {
                setTitle(e.target.value);
                clearMessages();
              },
            }}
          />
          <Select
            props={{
              id: "top",
              title: "Show In Top Safari",
              option: ["no", "yes"],
              onChange: (e: any) => {
                if (e.target.selectedIndex === 0) setShowTop(0);
                else setShowTop(1);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "venue",
              title: "Venue",
              type: "text",
              value: venue || "",
              onChange: (e: any) => {
                setVenue(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "formatted_address",
              title: "Formatted Address",
              type: "address",
              value: formattedAddress || "",
              onChange: (e: any) => {
                setFormattedAddress(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Date & Time"
        hint="Operating days and hours."
        icon={<FiClock className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          <InputField
            props={{
              id: "opened_days",
              title: "Open Days",
              type: "text",
              value: openedDays || "",
              onChange: (e: any) => {
                setOpenedDays(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "opened_at",
              title: "Opened At",
              type: "time",
              value: openedAt || "",
              onChange: (e: any) => {
                setOpenedAt(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "closed_at",
              title: "Closed At",
              type: "time",
              value: closedAt || "",
              onChange: (e: any) => {
                setClosedAt(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Pricing"
        hint="Optional pricing tiers."
        icon={<FiDollarSign className="h-4 w-4" />}
      >
        <Pricing pricing={pricing} setPricing={setPricing} />
      </AddSection>

      <ContactSection
        phone={phoneNumber}
        setPhone={setPhoneNumber}
        email={email}
        setEmail={setEmail}
        payLink={payLink}
        setPayLink={setPayLink}
        clearMessages={clearMessages}
      />

      <SocialSection
        whatsapp={whatsapp}
        setWhatsapp={setWhatsapp}
        facebook={facebook}
        setFacebook={setFacebook}
        twitter={twitter}
        setTwitter={setTwitter}
        instagram={instagram}
        setInstagram={setInstagram}
        youtube={youtube}
        setYoutube={setYoutube}
        clearMessages={clearMessages}
      />

      <AddSection title="Visibility" hint="Where this entry appears across the site.">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
          <Select
            props={{
              id: "safari_status",
              title: "Status",
              required: true,
              option: ["visible", "invisible"],
              onChange: (e: any) => {
                if (e.target.selectedIndex === 0) setSafariStatus(1);
                else setSafariStatus(0);
                clearMessages();
              },
            }}
          />
          <Select
            props={{
              id: "featured",
              title: "Featured",
              option: ["no", "yes"],
              onChange: (e: any) => {
                setFeatured(e.target.value);
                clearMessages();
              },
            }}
          />
          <Select
            props={{
              id: "promoted",
              title: "Promoted",
              option: ["no", "yes"],
              onChange: (e: any) => {
                setPromoted(e.target.value);
                clearMessages();
              },
            }}
          />
          <Select
            props={{
              id: "gallery",
              title: "Show in Gallery",
              option: ["no", "yes"],
              onChange: (e: any) => {
                const choice = e.target.value;
                setExpo(choice === "no" ? 0 : 1);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <DescriptionSection
        description={description}
        setDescription={setDescription}
        hashtags={hashtags}
        setHashtags={setHashtags}
        onGenerate={() => setShowDescriptionModal(true)}
        clearMessages={clearMessages}
      />
    </AddPageShell>
  );
};

export default Add;
